import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { warehouseListRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const warehouseListRouteMetadata: IRouteMetadataObj<
  typeof warehouseListRoutesObj
> = {
  list: {
    title: "basicInfo.index.title",
    description: "empty",
    lazy: () => import("@pages/basicInfo/warehouse/table/page"),
    mode: "index",
    type: "main",
    icon: "Information2Line",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "basicInfo.warehouseManagement.create.title",
    description: "empty",
    lazy: () => import("@/pages/basicInfo/warehouse/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "basicInfo.warehouseManagement.edit.title",
    description: "empty",
    lazy: () => import("@/pages/basicInfo/warehouse/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
  },
  shelvesList: {
    title: "basicInfo.warehouseManagement.shelvesList.title",
    description: "empty",
    lazy: () => import("@/pages/basicInfo/warehouse/shelves/table/page"),
    mode: "index",
    type: "inner",
    // TODO: WRONG ICON
    icon: "BookLine",
    breadcrumbs: [],
    permission,
  },
  addNewShelf: {
    title: "basicInfo.warehouseManagement.addNewShelf.title",
    description: "empty",
    lazy: () => import("@/pages/basicInfo/warehouse/shelves/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  editShelf: {
    title: "basicInfo.warehouseManagement.editShelf.title",
    description: "empty",
    lazy: () => import("@/pages/basicInfo/warehouse/shelves/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
  },
};

export const warehouseListRoutes = createRoute<typeof warehouseListRoutesObj>(
  warehouseListRoutesObj,
  warehouseListRouteMetadata,
);
